'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndHealth } from '../../Entities/Ind/IndHealth';
export class IndHealthRepository extends CoreRepository {
  public createIndHealth(indId: number, payload: any[]) {
    return this.webAPI.createIndHealth(indId, payload).then((response) => {
      const indHealth = new IndHealth();
      indHealth.hydrate(response);

      return indHealth;
    });
  }

  public removeIndHealth(indId: number, indHealthId: number) {
    return this.webAPI.removeIndHealth(indId, indHealthId).then((response) => {
      return response;
    });
  }

  public updateIndHealth(indId: number, indHealthId: number, payload: any[]) {
    return this.webAPI.updateIndHealth(indId, indHealthId, payload).then((response) => {
      return response;
    });
  }
}
